/**
 * トップページ用エントリ（common-top.js）
 * common-shared.js の後に読み込む。トップ専用のみ（slick・モーダル・タブ・ループスライド等）
 */
require("./index.js");
